import { render, staticRenderFns } from "./StoreDetailTemplate.vue?vue&type=template&id=5b44d78a&scoped=true&"
import script from "./StoreDetailTemplate.vue?vue&type=script&lang=js&"
export * from "./StoreDetailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b44d78a",
  null
  
)

export default component.exports